import styled, { css } from "styled-components"

import constants from "utils/constants"

import IntersectionChecker from "components/containers/common/IntersectionChecker"
import CommerceChallengeTutorialList from "components/presenters/commerce/tutorial/CommerceChallengeTutorialList"

export default function CommerceTutorial({ proofList, changeCurrTabByScroll }) {
  return (
    <>
      <IntersectionChecker
        options={{ rootMargin: "-150px 0px 0px 0px" }}
        onTopIntersectOut={() => {
          if (changeCurrTabByScroll) {
            changeCurrTabByScroll("tutorial")
          }
        }}
      />
      <div id="tutorial"> 
        <CommerceChallengeTutorialList /> 
        {Array.isArray(proofList) && proofList.length > 0 && (
          <ProofBlock>
            <BlockTitle>어떻게 인증하나요?</BlockTitle>
            <ProofList>
              {proofList.map((proofImg, index, arr) => (
                <ImgWrapper
                  key={`proof-img-list-item-${index}`}
                  width={arr.length < 3 ? "50%" : null}
                >
                  <SampleProofImg
                    src={`${constants.imagePath}/commerce/product/sample_proof_img/${proofImg}`}
                  />
                </ImgWrapper>
              ))}
            </ProofList>
          </ProofBlock>
        )}
      </div>
      <IntersectionChecker
        options={{ rootMargin: "0px 0px 0px 0px" }}
        onTopIntersectIn={() => {
          if (changeCurrTabByScroll) {
            changeCurrTabByScroll("tutorial")
          }
        }}
      />
    </>
  )
}

const BlockTitle = styled.h3`
  font-weight: 700;
  font-size: calc(100vw * (20 / 375));
  display: flex;
  align-items: center;
  color: #121212;
  margin-bottom: calc(100vw * (35 / 375));
`

const ProofBlock = styled.div`
  margin-bottom: calc(100vw * (46 / 375));
`

const ProofList = styled.ul`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`
const ImgWrapper = styled.div`
  width: 43%;
  flex: 0 0 auto;
  padding: 0 calc(100vw * (7 / 375));
  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `}
`
const SampleProofImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  image-rendering: -moz-crisp-edges; /* Firefox */
  image-rendering: -o-crisp-edges; /* Opera */
  image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
`
